module.exports = __webpack_public_path__ + "img/footer3.f178e630.svg";